const checkColor = {
	active: "#10284E",
	inactive: "#71717A",
};

function Check({ checked }) {
	return checked ? (
		<svg
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 4.90955C16.4183 4.90955 20 8.49127 20 12.9095C20 17.3278 16.4183 20.9095 12 20.9095C7.58172 20.9095 4 17.3278 4 12.9095C4 8.49127 7.58172 4.90955 12 4.90955ZM15.7071 11.6167C16.0976 11.2261 16.0976 10.593 15.7071 10.2024C15.3166 9.81191 14.6834 9.81191 14.2929 10.2024L11 13.4953L9.70711 12.2024C9.31658 11.8119 8.68342 11.8119 8.29289 12.2024C7.90237 12.593 7.90237 13.2261 8.29289 13.6167L10.2929 15.6167C10.6834 16.0072 11.3166 16.0072 11.7071 15.6167L15.7071 11.6167Z"
				fill={checked ? checkColor["active"] : checkColor["inactive"]}
			/>
		</svg>
	) : (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L10.5858 12L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29289Z"
				fill="#71717A"
			/>
		</svg>
	);
}

export default Check;
